import {useState,useEffect} from "react";
import styles from "./Aboutsection.module.css";
import img1 from "./images/audience.jpg";
import img2 from "./images/tedx.jpg"; 
import img3 from "./images/tedstage.jpg";

const content = [
  {
    title: "About TED",
    text: "TED, founded in 1984, is a global community dedicated to sharing ideas worth spreading Owned by a nonprofit foundation, TED aims to make great ideas accessible and spark meaningful conversations. Through its TEDx program, local communities and organizations can host TED-like events to foster connection and dialogue.",
    image: img1,
  },
  {
    title: "About TEDx",
    text: "Since 1984, TED has been a global platform for ideas worth spreading, uniting people from all disciplines and cultures to foster understanding. Owned by a nonprofit foundation, TED believes in the power of ideas to transform lives and the world. Its TEDx program empowers communities to host local TED-like events, sparking conversation and connection.",
    image: img2,
  },
  {
    title: "About TEDxIITGuwahati",
    text: "TEDxIITGuwahati, launched in 2016, is an annual event organized by IIT Guwahati students. Run by passionate volunteers, it offers a TED-like experience, fostering dialogue and collaboration through engaging talks and interactive sessions for the IIT Guwahati and wider Indian communities.",
    image: img3,
  },
];

export default function Aboutsection() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
        setIndex(prev => (prev + 1) % content.length);
    }, 10000);

    return () => clearInterval(timer);
    }, []);


  return (
    <section className={styles.about}>
      <h1 className={styles.title}>The World of TED</h1>

      <div className={styles.card}>
        <div className={styles.tabs}>
          {content.map((item, i) => (
            <span
              key={i}
              className={i === index ? styles.active : ""}
              onClick={() => setIndex(i)}
            >
              {item.title}
            </span>
          ))}
        </div>

        <div className={styles.body} fade>
          <div className={styles.text}>
            <h2>{content[index].title}</h2>
            <p>{content[index].text}</p>
            {/* <button className="cta">Learn More</button> */}
          </div>

          <div className={styles.image}>
            <img src={content[index].image} alt="TED" />
          </div>
        </div>

        <div className={styles.dots}>
          {content.map((_, i) => (
            <span
              key={i}
              className={i === index ? "active" : ""}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      </div>

       <div className={styles.features}>
        <div className={styles.feature}>
          <div className={styles.icon}>💡</div>
          <h3>Inspiring Ideas</h3>
          <p>Promoting innovative and thought-provoking ideas worth spreading</p>
        </div>

        <div className={styles.feature}>
          <div className={styles.icon}>🤝</div>
          <h3>Community Driven</h3>
          <p>Organized and run by IIT Guwahati students and passionate volunteers</p>
        </div>

        <div className={styles.feature}>
          <div className={styles.icon}>💬</div>
          <h3>Dialogue & Collaboration</h3>
          <p>Fostering engaging discussions and collaborative activities</p>
        </div>
      </div>
    </section>
  );
}